import { Pagination } from "../utils";

export interface Institution {
	id: number
	name: string
	business_name?: string
	address?: string | null
	surgery_place_id?: number | null
}
export interface InstitutionPayload {
	name: string;
	phone_number?: string | null;
	address?: string | null;
}


export interface InstitutionList {
	institution_list: InstitutionListItem[];
	pagination: Pagination;
}

export interface InstitutionListResponse {
	status: boolean;
	data: InstitutionListItem[];
	pagination: Pagination;
}


export interface InstitutionListItem {
	id: number
	name: string
	phone_number: string | null
	address: string | null
}

export interface FetchInstitutionsQueryParam {
	page: string | number;
	id: string | number;
	name: string;
	phone_number: string | number;
	address: string;
	order_by: string;
	order_direction: 'asc' | 'desc';
	per_page: number | string;
}


// institution study 
export interface InstitutionStudy {
  institution_id: number;
  institution_name: string;
  institution_address: string;
	medic_ids: InstitutionSelectorRequest[]
}

// select medic institution
export interface InstitutionSelectorRequest {
  medic_id: number;
}

//select institution
export interface InstitutionSelectorSubmit {
  institution_id: number;
}

//institution select response
export interface InstitutionSelectorResponse {
  institutions: InstitutionStudy[];
}

export interface InstitutionSimpleListResponse {
	message: string;
	data: Institution[];
}
